import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-verify2',
  templateUrl: './verify2.component.html',
  styleUrls: ['./verify2.component.scss']
})
export class Verify2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/verify2/verify2.component.ts